"use client";
import React from "react";
import clsx from "clsx";

export default function TestimonialDefault({data}) {
    const {title, subtitle, quotes = [], align = "center", background = {}} = data || {};

    const bgStyle =
        background.type === "gradient"
            ? {backgroundImage: background.value}
            : background.type === "color"
                ? {backgroundColor: background.value}
                : background.type === "image"
                    ? {
                        backgroundImage: `url(${background.value})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }
                    : {};

    const alignClass =
        align === "center"
            ? "text-center"
            : align === "right"
                ? "text-right"
                : "text-left";

    return (
        <section className="py-20 px-4" style={bgStyle}>
            <div className="max-w-7xl mx-auto">
                {title && <h2 className={clsx("text-3xl font-bold mb-2", alignClass)}>{title}</h2>}
                {subtitle && <p className={clsx("text-gray-600 mb-8", alignClass)}>{subtitle}</p>}

                <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                    {quotes.map((q, idx) => (
                        <div key={idx} className="bg-white p-6 rounded-xl shadow-md">
                            <p className="italic text-gray-700">“{q.quote}”</p>
                            <div className="mt-4 flex items-center gap-4">
                                {q.avatar && (
                                    <img
                                        src={q.avatar}
                                        alt={q.author}
                                        className="w-12 h-12 rounded-full object-cover"
                                    />
                                )}
                                <div>
                                    <p className="font-semibold">{q.author}</p>
                                    <p className="text-sm text-gray-500">{q.role}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}